import {Inject, Injectable } from '@angular/core';
import {_,moment} from '../../js/globals.js';
import { MySynchConstantService } from './mysynch.constant.service';

@Injectable({
    providedIn: 'root',
})
export class ModalDataService {
   
   
    private outofdateDataExcludeStates: string[] = ['Login', 'Welcome', 'WelcomeToFarm', 'ForgotPassword', 'PasswordReset'
                                                    ,'Help','User','Alerts','MultiFarmDashboard','Definitions','AdminUserManagement'
                                                    ,'AdminUserManagementMaint','FarmManagement','FarmManagementMaint','TerritoryDashboard'
                                                    ,'NewFarm','EmmRetrieveShotList','FarmAdmin','BreedingCodes','HerdData','UserManagement','FertilityCodes'];
    private noMetaDataDateExcludeStates: string[] = ['Login', 'Welcome', 'WelcomeToFarm', 'ForgotPassword', 'PasswordReset'
                                                    ,'Help','User','Alerts','MultiFarmDashboard','Definitions','AdminUserManagement'
                                                    ,'AdminUserManagementMaint','FarmManagement','FarmManagementMaint','TerritoryDashboard'
                                                    ,'NewFarm','EmmRetrieveShotList','FarmAdmin','BreedingCodes','HerdData','UserManagement','FertilityCodes'];

    constructor(@Inject('MySynchFactory') protected MSF: any,
    @Inject('ApiFactory') protected api: any,
    @Inject(MySynchConstantService) protected mySynchConstantService: MySynchConstantService) {

    }
    // function that returns the outofdateDataExcludeStates array
    getOutofdateDataModalExcludeStates(){
        return this.outofdateDataExcludeStates;
    }
    getNoMetaDataDateModalExcludeStates(){
        return this.noMetaDataDateExcludeStates;
    }
    // function that gets the outofdateData numDaysOldLimit from code file
    getOutOfDateDataNumDaysOldLimit(){
       var outOfDateDataCodeFileConfig  = this.MSF.getParsedCodeFileItemByCodeAndCodeType('SITEMODALCONFIGS','OUTOFDATEDATA');
       var outOfDateDataNumDaysOldLimit = _.get(outOfDateDataCodeFileConfig,'details.numDaysOldLimit',13);
       return outOfDateDataNumDaysOldLimit;
    }
     // function that gets the outofdateData numDaysExtendedHideLimit from code file
     getOutOfDateDataNumDaysExtendedHideLimit(){
        var outOfDateDataCodeFileConfig  = this.MSF.getParsedCodeFileItemByCodeAndCodeType('SITEMODALCONFIGS','OUTOFDATEDATA');
        var outOfDateDataNumDaysExtendedHideLimit = _.get(outOfDateDataCodeFileConfig,'details.numDaysExtendedHideLimit',15);
        return outOfDateDataNumDaysExtendedHideLimit;
     }
     getNoMetaDataDateNumDaysExtendedHideLimit(){
        var noMetaDataDateCodeFileConfig  = this.MSF.getParsedCodeFileItemByCodeAndCodeType('SITEMODALCONFIGS','NOMETADATADATE');
        var noMetaDataDateNumDaysExtendedHideLimit = _.get(noMetaDataDateCodeFileConfig,'details.numDaysExtendedHideLimit',15);
        return noMetaDataDateNumDaysExtendedHideLimit;
    }
     
    async getOutOfDateDataExpireDate(personId,herdId): Promise<string>{
        return new Promise((resolve, reject) => {
          var outOfDateExpireDate = undefined;
          var appLevelNotificationId = _.get(_.find(_.get(this.MSF,'lists.appLevelNotifications',[]),{name:this.mySynchConstantService.outofdateDataNotificationName}),'notificationId');
          if(navigator.onLine){
              this.api.getPersonAppLevelNotificationsExpiryDate(personId,herdId,appLevelNotificationId,(err,results)=>{
                  if(err){
                      reject(err);
                  }else{
                      // we remove the "Z" from the date string so that the timezone is not added to the date
                        var expiryDate = _.get(results,'expiryDate') as string;
                        if(!_.isUndefined(expiryDate) && !_.isNull(expiryDate)){
                            expiryDate = expiryDate.replace('Z','');
                        }
                     
                      resolve(expiryDate);
                  }
              });
          }else{
              var existingOutofdateDataExpiries = this.MSF.getParsedLocalStorageItem(this.mySynchConstantService.outofdateDataExpiries);
              var outofdateDataExpiry = _.get(_.find(existingOutofdateDataExpiries, { 'herdId': herdId, 'personId': personId }), 'expiry') as string;
             
              resolve(outofdateDataExpiry);
          }
       });
      }
      async getNoMetaDataDateExpireDate(personId,herdId): Promise<string>{
        return new Promise((resolve, reject) => {
        var appLevelNotificationId = _.get(_.find(_.get(this.MSF,'lists.appLevelNotifications',[]),{name:this.mySynchConstantService.noMetaDataDateNotificationName}),'notificationId');
          var noMetaDataDateExpireDate = undefined;
          if(navigator.onLine){
              this.api.getPersonAppLevelNotificationsExpiryDate(personId,herdId,appLevelNotificationId,(err,results)=>{
                  if(err){
                      reject(err);
                  }else{
                      // we remove the "Z" from the date string so that the timezone is not added to the date
                        var expiryDate = _.get(results,'expiryDate') as string;
                        if(!_.isUndefined(expiryDate) && !_.isNull(expiryDate)){
                            expiryDate = expiryDate.replace('Z','');
                        }
                     

                  
                      resolve(expiryDate);
                  }
              });
          }else{
              var existingOutofdateDataExpiries = this.MSF.getParsedLocalStorageItem(this.mySynchConstantService.noMetaDataDateExpiries);
              var outofdateDataExpiry = _.get(_.find(existingOutofdateDataExpiries, { 'herdId': herdId, 'personId': personId }), 'expiry') as string;
             
              resolve(outofdateDataExpiry);
          }
       });
      }
}